
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class EditModal extends Vue {

    @Prop({
        default: () => new OM.ProductionProcessConfigurationVM()
    }) model: OM.ProductionProcessConfigurationVM;
    
    @Prop({
        default: () => []
    }) productionPhases: OM.TextIdentifier[];

    localCompanyList: OM.TextIdentifier[] = [];
    localModel: OM.ProductionProcessConfigurationVM = new OM.ProductionProcessConfigurationVM();
    selectedCompany: string = "";

    isOptionalDetailedProcess: boolean = false;
    optionalDetailedProcessType: number = -1;

    @Prop() callback: any;
    @Prop() callbackOptionalDetailed: any;

    created() {
        this.localModel = this.model;
    }

    getCompanyName(identifier: string){
        return this.localCompanyList.find( x => x.identifier == identifier).text;
    }

    get canSave(){
        return this.localModel.name && this.localModel.productionPhase.identifier && this.localModel.emissionFactor;
    }

    save() {
        if(!this.canSave)
            return;

        if(!this.isOptionalDetailedProcess)
            this.callback(this.localModel);
        else
            this.callbackOptionalDetailed(this.localModel, this.optionalDetailedProcessType);
    }
    
}
